export default "/institutions/pagbank.svg";